const EARTH_RADIUS_MILES = 3958.8;
const REMOTE_WORK_DISTANCE_THRESHOLD_MILES = 35;

function calculateDistanceMiles(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function isEligibleForRemoteWork(
  userLat: number,
  userLon: number,
  customerLat: number,
  customerLon: number
): boolean {
  return (
    calculateDistanceMiles(userLat, userLon, customerLat, customerLon) >=
    REMOTE_WORK_DISTANCE_THRESHOLD_MILES
  );
}

function getBrowserGeolocation(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: false,
      maximumAge: 300000,
    });
  });
}

export {
  calculateDistanceMiles,
  isEligibleForRemoteWork,
  getBrowserGeolocation,
  REMOTE_WORK_DISTANCE_THRESHOLD_MILES,
};
